import { onDomReady } from '../utils/dom';

/**
 * @type {HTMLElement|null}
 */
let root = null;

/**
 * @type {HTMLElement|null}
 */
let inside = null;

/**
 * @type {HTMLElement|null}
 */
let container = null;

// Get the height of the header by the top offset of the next element
export const getHeight = () => container.offsetTop.toFixed(0);

// Get the current height of header_inside.
export const getInnerHeight = () => inside.getBoundingClientRect().height.toFixed(1);

// Get the position from which the header should be fixed.
export const getFixedPosition = () => window.innerHeight / 2;

function showFixedHeader() {
    const scrolledTop = document.documentElement.scrollTop;
    const classList = root.classList;

    if (scrolledTop > Number.parseInt(getHeight())) {
        classList.add('sticky');

        if (classList.contains('menu-open') || classList.contains('level-open')) {
            classList.add('keep');
        }

        if (scrolledTop > getFixedPosition()) {
            classList.add('show');
        } else {
            classList.replace('show', 'hide');
        }
    } else {
        classList.remove('sticky', 'hide', 'keep', 'show');
    }
}

onDomReady(() => {
    root = document.querySelector('#fixed-header') ?? document.querySelector('#header');
    inside = root.querySelector('.header_inside');
    container = document.querySelector('#header + div');

    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    showFixedHeader();
});
